module.exports = __webpack_public_path__ + "img/Stemness-PDAC_GSE111672.5633c376.png";